//natives
import React from "react";
import {CircularProgress,Paper,Typography} from "@material-ui/core";
import MUIDataTable from "mui-datatables";

import Columns from '../childrens/columns/.mixins/index';

//components
import Error from "../../../../../../../util/error/.mixins/Error";

//css
import ConfOpcoesRecebimentoListaCss from './confOpcoesRecebimentoListaCss';
const useStyles = ConfOpcoesRecebimentoListaCss();

export default function GrupoOpcoes(props) {
    const classes = useStyles();
    const options = {
        pagination: false,
        filter: false,
        search: false,
        print: false,
        selectableRows: false,
        download: false,
        viewColumns: false,
        customToolbar: null,
        responsive: "simple"
    };
    const columns = Columns(props);
    return (
        <div className="container" style={{maxWidth:700}} >
                
            <br/>
            {props.state.isLoading &&
                <div align="center">
                    <CircularProgress />
                </div>
            } 
            {!props.state.isLoading && !props.state.isError &&
                <Paper className={classes.root}>
                    <Typography variant="h6" gutterBottom>
                        {props.state.title}
                    </Typography>
                    {props.state.itens.length > 0 &&
                        <>
                            {props.state.itens.map((e,i) => {
                                return (
                                    <>
                                        {e.Array.length > 0 &&
                                            <MUIDataTable
                                                key={i}
                                                title={`Condições de pagamento padrão de ${e.NR_PRAZO} dias`}
                                                data={e.Array}
                                                columns={columns}
                                                options={options}
                                            />
                                        }
                                    </>
                                );
                            })}
                        </>
                    }
                    {props.state.itens.length == 0 &&
                        <Typography variant="body" gutterBottom>
                            {"Nenhum registro foi encontrado!"}
                        </Typography>
                    }
                </Paper>
            }

            {props.state.isError &&
                <div align="center">
                    <Error text={props.state.error}/>
                </div>
            }

        </div>
    );

}